/**
 * ============================================================================
 * 联系方式内容 - Contact Content
 * ============================================================================
 *
 * 【作用】控制“联系我们”弹窗的标题、副标题，联系信息（地址/邮箱/电话/办公室），以及“加入我们”区块的职位列表与申请按钮。
 * 【如何修改】直接改下面对象中对应字段的 en/cn 或字符串；positions 数组中可增删职位，applyLink 为申请邮件链接。
 *
 * 【参数说明】
 * - info.address / phone / office: 联系信息，phone/office 可做中英对象
 * - joinUs.positions: 数组，每项 { title: {en,cn}, desc: {en,cn} }
 * - joinUs.applyButton / applyLink: 申请按钮文案与 mailto 链接
 */

export const contactContent = {
  title: { en: "Contact Us", cn: "联系我们" },
  subtitle: { en: "Get in touch with us", cn: "与我们取得联系" },
  info: {
    address: {
      en: "Department of Chemistry, Southern University of Science and Technology, Shenzhen, China",
      cn: "南方科技大学化学系，深圳市南山区，中国"
    },
    email: "boyuqie@outlook.com",
    // phone: { en: "此处可填写英文电话", cn: "此处可填写中文电话" },  // 可选
    office: { en: "Department of Chemistry, College of Science", cn: "化学系，理学院" }
  },
  joinUs: {
    title: { en: "Join Us", cn: "加入我们" },
    subtitle: { en: "We are always looking for talented researchers to join our team", cn: "我们一直在寻找有才华的研究人员加入我们的团队" },
    positions: [
      {
        title: { en: "PhD & Master Students", cn: "博士与硕士研究生" },
        desc: {
          en: "We welcome applications from students with backgrounds in chemistry, physics, electrical engineering, materials science, or computer science. And we welcome students interested in interdisciplinary research",
          cn: "我们欢迎具有化学、物理、电气工程、材料科学或计算机科学背景的学生申请，同时欢迎对跨学科研究感兴趣的学生申请。"
        }
      },
      {
        title: { en: "Research Assistant", cn: "研究助理" },
        desc: {
          en: "We welcome applications from students with backgrounds in chemistry, physics, electrical engineering, materials science, or computer science. And we welcome students interested in interdisciplinary research",
          cn: "我们欢迎具有化学、物理、电气工程、材料科学或计算机科学背景的学生申请，同时欢迎对跨学科研究感兴趣的学生申请。"
        }
      },
      {
        title: { en: "Postdoctoral Researchers", cn: "博士后研究员" },
        desc: {
          en: "We welcome applications from postdocs with expertise in organic synthesis, condensed matter experimental characterization, theoretical calculation, nanodevices/MEMS, or machine learning.",
          cn: "我们欢迎在有机合成、凝聚态实验表征、理论计算、纳米器件/MEMS或机器学习方面有专长的博士后申请。"
        }
      },
    ],
    applyButton: { en: "How to Apply/Application Requirements", cn: "如何申请/申请要求" },
  }
};
